import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Container,
  Title,
  Paper,
  Text,
  Stack,
  Card,
  Group,
  Button,
  LoadingOverlay,
} from '@mantine/core';
import { IconTruck } from '@tabler/icons-react';
import { RootState } from '../store';

import { ShipperResponse } from 'types/responses.type';
import shipperService from 'services/shipper.service';

export function ShipperSelector() {
  const navigate = useNavigate();
  const [shippers, setShippers] = useState<ShipperResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    // Redirect if user is not admin or support
    if (user && !['ADMIN', 'SUPPORT'].includes(user.type)) {
      navigate('/dashboard');
      return;
    }

    loadShippers();
  }, [user, navigate]);

  const loadShippers = async () => {
    setLoading(true);
    const response = await shipperService.getShippers();
    setLoading(false);

    if (response.ok && response.data) {
      setShippers(response.data ?? []);
    } else {
      setError(response.errorMessage || 'Failed to load shippers');
    }
  };

  const handleSelectShipper = (shipperId: number) => {
    localStorage.setItem('owlara_selected_shipper', shipperId.toString());
    navigate('/dashboard');
    window.location.reload()
  };

  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <Title order={2}>Select Shipper</Title>
        <Text c="dimmed">
          Please select a shipper to view their dashboard and manage their operations
        </Text>

        <Paper p="md" radius="md" withBorder>
          <Stack gap="md" pos="relative">
            <LoadingOverlay visible={loading} />

            {error && (
              <Text c="red" size="sm">
                {error}
              </Text>
            )}

            {shippers?.map((shipper) => (
              <Card key={shipper.shipperId} withBorder shadow="sm">
                <Group justify="space-between" align="center">
                  <Group gap="md">
                    <IconTruck size={24} color="#4dabf7" />
                    <div>
                      <Text fw={500}>{shipper.companyName}</Text>

                    </div>
                  </Group>
                  <Button
                    variant="light"
                    onClick={() => handleSelectShipper(shipper.shipperId)}
                  >
                    Select
                  </Button>
                </Group>
              </Card>
            ))}

            {!loading && shippers.length === 0 && (
              <Text ta="center" c="dimmed">
                No shippers found
              </Text>
            )}
          </Stack>
        </Paper>
      </Stack>
    </Container>
  );
} 